<template>
    <div>
        <div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
             aria-hidden="true">

            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">View Editor</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="row mb-3">
                                <label for="nameInput" class="col-sm-3 col-form-label">Name</label>
                                <div class="col-sm-9">
                                    <input id="nameInput" type="text" class="form-control" placeholder="view name"
                                           v-model="view.name">
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label for="viewTypeOptions" class="col-sm-3 col-form-label">View Type</label>
                                <div class="col-sm-9">
                                    <select id="viewTypeOptions" class="form-select" v-model="view.view_type">
                                        <option v-for="viewTypeOption in model.viewTypeOptions">{{viewTypeOption}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="descInput" class="col-sm-3 col-form-label">Description</label>
                                <div class="col-sm-9">
                                    <textarea id="descInput" type="text" class="form-control" placeholder="View description"
                                              v-model="view.layout.description"></textarea>
                                </div>
                            </div>

                            <div class="mb-3">
                                <on-off-control :object="view" field="published" label="Make public"></on-off-control>
                            </div>

                            <div class="mb-3" v-if="view.view_type === 'kanban'">
                                <label for="viewGroupOptions">Group Field</label>
                                <select id="viewGroupOptions" class="form-select" v-model="view.group_field_id">
                                    <option v-for="field in table.fields" :value="field.index">{{field.name}}</option>
                                </select>
                            </div>


                        </form>
                    </div>

                    <div v-if="errorMessage" class="alert alert-danger" role="alert">
                        {{errorMessage}}<br>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn modal-btn btn-primary " style="min-width: 150px;"
                                @click="yesHandler">Ok
                        </button>
                        <button type="button" class="btn modal-btn btn-secondary " style="min-width: 150px;"
                                @click="noHandler">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import ArrayUtil from "../../utils/ArrayUtil";
    import ViewService from "../../services/ViewService";
    import OnOffControl from "../../components/OnOffControl.vue";

    export default {
        name: 'ViewModal',
        components: {OnOffControl},
        props: {
            yesEvent: Function,
            view: Object,
            table: Object
        },
        data() {
            return {
                model: webase.model,
                service: new ViewService(),
                arrayUtil: new ArrayUtil(),
                app: webase.model.app,
                errorMessage: null,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('viewModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {

                if (this.view.id === null) {
                    this.create()
                } else {
                    this.update()
                }

                // call the parent's "yesEvent"
                if (this.yesEvent) {
                    this.yesEvent()
                }

                // hide the modal
                this.noHandler()
            },
            create() {
                let request = {
                    view: this.view
                }

                this.service.create(request).then((response) => {
                    this.table.views.push(response)
                    let nextRoute = this.view.view_type === 'custom' || this.view.view_type === 'form' ?  'view-editor' : 'view-renderer'
                    this.$router.push({name: nextRoute, params: {id: response.id}})

                }).catch((message) => {
                    console.log('error creating view')
                    console.log(message)
                })
            },
            update() {
                let request = {
                    view: {
                        name: this.view.name,
                        view_type: this.view.view_type,
                        published: this.view.published,
                        group_field_id: this.view.group_field_id,
                        layout: this.view.layout
                    }
                }

                this.service.update(this.view.id, request).then((response) => {
                    this.arrayUtil.update(this.table.views, response)
                    webase.eventDispatcher.emit('viewUpdated', this.view)
                }).catch((message) => {
                    console.log('error updating view')
                    console.log(message)
                })
            }
        }
    }
</script>